module.exports = __webpack_public_path__ + "static/media/scrum1.0dcfbf99.png";